import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class RolePresenter extends EntityPresenter {
  static urn = 'roles'
  static key = 'role'

  static navOptions(key = 'roles') {
    const routes = {
      roles: {
        icon: 'assignment_ind',
        pageRoutes: ['role'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(RolePresenter)
